import { useState, useRef, useEffect, useContext, useMemo } from "react"
import LeftComp from "./LeftComp/LeftComp"
import MiddleComp from "./MiddleComp/MiddleComp"
import RightComp from "./RightComp/RightComp"
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext';
import {workflowOfBuild} from '@utils/workflowOfBuildTask';
import { maskDispose, maskPrediction } from "@utils/workflowOfPrediction"
import Utils from '@utils/utils'
import { message } from "antd"
import API from '@api/api'
import { IMAGE_TYPE, CLOTH_TYPE, ALGO_TYPE } from "@utils/CONST"
import { GenerateContext, GenerateContextProvider } from "@utils/GenerateContext"
import LeftCompVideo from "./LeftCompVideo"
import MiddleCompVideo from "./MiddleCompVideo"
import MiddleModelVideo from "./MiddleModelVideo"
import LeftModelVideo from "./LeftModelVideo"
import PSAIModal from '@PSAIComponents/PSAIModal';

const SelfModelFakeChildren = (props) => {
    const {
        updateConfig,
        globalModelFilter,
        filteredModelListRef,
        filteredBgListRef,
        forceUpdate,
        setGlobalLoading,
    } = useContext(AppContext);

    const {
        imageType, // model/dressform/clothes...
        inputImage, // 原始输入图： 真人/人台/衣服图-套装
        inputImageTop, // 原始输入图：衣服图-上装
        inputImageBottom, // 原始输入图：衣服图-下装
        dragScaleRef, // 商品+softedge布局等
        maskAlgoIdRef, // mask算法id-套装
        maskAlgoId1Ref, // mask算法id-上身
        maskAlgoId2Ref, // mask算法id-下身
        segmentResult, // 分割结果列表-套装
        segmentResult1, // 分割结果列表-上身
        segmentResult2, // 分割结果列表-下身
        modelStyle, // 选择的模特
        poseStyle, // 选择的姿势
        bgStyle, // 选择的场景
        outputMaxSize, // 决定商品生成参数upscale_enable是1/0
        projectId, setProjectId, // 生成的项目id
        rightProjectId, setRightProjectId, // 右侧的项目id
        projectName, // 生成的项目名
        createNum, // 生成数量
        clothType, // 来自服装类型的选择，仅用于衣服图的区分
        subBgId, // 场景内部子index，目前只能为-1
        faceTag, // 特征属性：表情
        hairTag, // 特征属性：发型
        faceTagText, // 特征属性：表情
        hairTagText, // 特征属性：发型
        // 商品自定义尺寸
        imgWidthRef,
        imgHeightRef,
        imgRatioRef,
        // 自定义场景字段
        definedFlag,
        positivePrompt,
        refImg,
        refImgMask,
        refVersion,
        refStrength,
        defaultPositivePrompt,
        defaultNegativePrompt,
        defaultBkgUrl,
        // 自定义模特
        isSelfDefinedRef,
        selfDefinedImgRef,
        imageAntispamId,
        // 商品视频
        img4Video, videoResolution,
        // 模特视频
        modelVideo, modelVideoVersion, modelVideoPic,
        scaleRateRef, ltXRef, ltYRef,
        coordDrag,
        imgClipSize,
        isSceneFracturing,
        dpScale,
        keepPose,
    } = useContext(GenerateContext)

    const isMounted = useRef(true) // 判断组件是否已销毁

    useEffect(() => {
        // 设置sidebar key
        updateConfig({sidebarKey: imageType})
        return () => {
            isMounted.current = false
        }
    }, [])


    const onCreate = async () => {
        // console.log('==生成==')
        setGlobalLoading('生成中')
        try {
            if (imageType == IMAGE_TYPE.COMMODITY) {
                if (!bgStyle) throw new Error('请先选择背景！')
            } else if (imageType == IMAGE_TYPE.CLOTHES) { // virtualtryon功能测试
                if (!modelStyle) throw new Error('请先选择模特！')
            } else {
                if(!bgStyle || !modelStyle) throw new Error('请先选择模特或背景！')
            }
            const ver = await API.getVersion()
            const version = imageType == IMAGE_TYPE.COMMODITY ? // 商品
                                ver?.commodityVersion :
                                imageType == IMAGE_TYPE.CLOTHES ? // tryon
                                    ver?.tryOnVersion :
                                    ver?.modelVersion
            const res2 = await inpaintPrediction(version)
            if (!res2) return
            // console.log('projectid', res2)
            setProjectId(res2)
            setRightProjectId(res2)
            forceUpdate({jumpOnce: true})
        } catch (err) {
            message.warning(err.message)
        } finally {
            setGlobalLoading(false)
        }
    }

    const inpaintPrediction = async (version) => {
        if (
            (/_default_style$/.test(modelStyle) && filteredModelListRef.current.length == 0 && imageType != IMAGE_TYPE.COMMODITY) ||
            (/_random$/.test(bgStyle) && filteredBgListRef.current.length == 0)
        ) {
            throw new Error('请选择一个模特/场景')
        }

        let segmentResult0OffsetImg = segmentResult[0]
        let segmentResult3OffsetImg = segmentResult[3]
        let segmentResult4OffsetImg = segmentResult[4]
        let segmentResult5OffsetImg = segmentResult[5]
        let segmentResult6OffsetImg = segmentResult[6]
        // 保持原图场景/场景裂变，使用原图mask
        if (imageType == IMAGE_TYPE.MODEL && !(bgStyle == '00_keep' || isSceneFracturing)) {
            // 制作偏移图像
            segmentResult0OffsetImg = await Utils.uploadBase64Image(await Utils.makeOffsetImgByFabric(segmentResult[0], scaleRateRef.current, ltXRef.current, ltYRef.current, imgClipSize.width, imgClipSize.height))
            segmentResult3OffsetImg = await Utils.uploadBase64Image(await Utils.makeOffsetImgByFabric(segmentResult[3], scaleRateRef.current, ltXRef.current, ltYRef.current, imgClipSize.width, imgClipSize.height))
            segmentResult4OffsetImg = await Utils.uploadBase64Image(await Utils.makeOffsetImgByFabric(segmentResult[4], scaleRateRef.current, ltXRef.current, ltYRef.current, imgClipSize.width, imgClipSize.height))
            segmentResult5OffsetImg = await Utils.uploadBase64Image(await Utils.makeOffsetImgByFabric(segmentResult[5], scaleRateRef.current, ltXRef.current, ltYRef.current, imgClipSize.width, imgClipSize.height))
            segmentResult6OffsetImg = await Utils.uploadBase64Image(await Utils.makeOffsetImgByFabric(segmentResult[6], scaleRateRef.current, ltXRef.current, ltYRef.current, imgClipSize.width, imgClipSize.height))
        }

        const keepBkg = definedFlag == 1 ? 0 : // 自定义场景，keepBkg=0
                        isSceneFracturing ? 1 :                
                        bgStyle == '00_keep' ? 2 : 0
                        

        let obj = imageType == IMAGE_TYPE.MODEL? {
            img_path: segmentResult0OffsetImg, //segmentResult[0],  // 分割结果
            mask_path: segmentResult3OffsetImg, // segmentResult[3],
            mask_path_cloth: segmentResult4OffsetImg, // segmentResult[4],
            lt_x: ltXRef.current || 0,
            lt_y: ltYRef.current || 0,
            scale_rate: scaleRateRef.current,
            coord_drag: coordDrag ? JSON.stringify(coordDrag) : "",
            prompt: positivePrompt, // 自定义提示词
            negative_prompt: defaultNegativePrompt.current, //负提示词  当前是写死
            seed: -1,
            sub_bgid: subBgId,  // 场景内部子index，目前只能为-1
            bkg_url: refImg, // 自定义场景参考图
            ip_scale: refStrength, // 自定义场景强度
            steps: 30,
            cfg: 7,
            defined_flag: definedFlag, // 自定义场景1，否则为0
            mote_style: modelStyle, // 模特
            mote_bg_style: bgStyle, // 背景
            version: version, // 模特/人台算法增加字段version
            upscale_enable: 0,
            faceRestore_enable: 1,
            style_info: 1,
            faceshape_style: '', // 新增参数，默认传空
            modelKeyList: filteredModelListRef.current, // modalStyle传随机(_default_style)时使用
            bgKeyList: filteredBgListRef.current, // bgUrl传随机(_random)时使用
            gender: null,
            cloth_type: 2,  // 来自服装类型的选择，仅用于衣服图的区分 默认2
            skin_maskpath: segmentResult5OffsetImg, // segmentResult[5] || '', // 模特增加手部mask
            hair_maskpath: segmentResult6OffsetImg, // segmentResult[6] || '', // 模特增加发型mask
            tryon_flag: 0,
            num: createNum, //生成几张
            extra_property: [hairTag, faceTag].filter(item => item !== "default").join(','), // 特征
            keep_bkg: keepBkg, // 仅重绘皮肤区域
            dp_scale: dpScale // 场景裂变
        } : imageType == IMAGE_TYPE.COMMODITY? {
            img_path: segmentResult[0],
            mask_path: segmentResult[4],
            imgs_dict: JSON.stringify(dragScaleRef.current), // 这是商品在画布上的位置，旋转，层级，大小等信息，可以在浏览器里面拷贝出来参考
            p_prompt: positivePrompt, // 自定义场景提示词
            n_prompt: "",
            sample_mtd: "Eular a",
            seed: -1,
            ref_img: refImg, // 自定义场景参考图
            ref_img_mask: refImgMask, // 自定义场景参考图mask
            refine_version: refVersion, // v1-生成同款 v2-相似风格  下两个参数是自定义参考图两个强度，同款和相似风格
            ref_strength: refVersion == 1 ? refStrength : 0.3, // v1, default 0.3  
            ref_prompt_strength: refVersion == 2 ? refStrength : 0.7, // v2, default 0.7
            steps: 20,
            cfg: 7,
            defined_flag: definedFlag, // 自定义场景1，否则为0 
            goods_bg_style: bgStyle, //背景
            bgKeyList: filteredBgListRef.current, // bgUrl传随机(_random)时使用
            version: version, // 算法增加字段version
            upscale_enable: outputMaxSize >= 1024 ? 1: 0, 
            num: createNum,
            canvas_width: imgWidthRef.current, //画布宽高，对应生成图大小
            canvas_height: imgHeightRef.current,
        }: {
            img_path: segmentResult[0],
            mask_path_cloth: segmentResult[4],
            lt_x: 1,
            lt_y: 1,
            scale_rate: 1.3,
            prompt: positivePrompt || defaultPositivePrompt.current, //自定义场景提示词，不传就是默认
            negative_prompt: defaultNegativePrompt.current,
            seed: -1,
            sub_bgid: subBgId,  // 场景内部子index，目前只能为-1
            bkg_url: refImg || defaultBkgUrl.current, // 自定义场景参考图，没有前端就默认传个URl，前
            steps: 20,
            cfg: 7,
            defined_flag: definedFlag, // 场景内部子index，目前只能为-1
            mote_style: modelStyle,
            mote_bg_style: bgStyle,
            version: version, // 算法增加字段version
            upscale_enable: 0,
            faceRestore_enable: 1,
            body_mask_path: segmentResult[3],
            faceshape_style: '', // 新增参数，默认传空
            modelKeyList: filteredModelListRef.current, // modalStyle传随机(_default_style)时使用
            bgKeyList: filteredBgListRef.current, // bgUrl传随机(_random)时使用
            gender: null, 
            cloth_type: 2, //固定为2 
            num: createNum
        }
        let mask = {algoId: maskAlgoIdRef.current, editedOutput: segmentResult}
        let input_image = inputImage || segmentResult[0]
        // virtualtryon功能测试
        if (imageType == IMAGE_TYPE.CLOTHES) {
            let _clothType = 0 // 衣服图的cloth_type目前仅与上传的衣服数量有关：0-上装；1-下装；2-上下装；3-裙装；by ligd 20240517
            let cloth_path = segmentResult[0]
            let cloth_mask = segmentResult[4]
            if (clothType == CLOTH_TYPE.SUIT) { // 套装
                if (segmentResult1.length == 0 && segmentResult2.length == 0) return message.warning('请至少上传一件衣服')
                if (segmentResult1.length == 0) { // 只传了下装
                    _clothType = 1
                    input_image = inputImageBottom || segmentResult2[0]
                    cloth_path = segmentResult2[0]
                    cloth_mask = segmentResult2[4]
                    mask = {bottomAlgoId: maskAlgoId2Ref.current, bottomEditedOutput: segmentResult2}
                } else if (segmentResult2.length == 0) { // 只传了上衣
                    _clothType = 0
                    input_image = inputImageTop || segmentResult1[0]
                    cloth_path = segmentResult1[0]
                    cloth_mask = segmentResult1[4]
                    mask = {topAlgoId: maskAlgoId1Ref.current, topEditedOutput: segmentResult1}
                } else { // 套装，上衣下装都传了
                    _clothType = 2
                    input_image = (inputImageTop && inputImageBottom) ? `${inputImageTop},${inputImageBottom}` : `${segmentResult1[0]},${segmentResult2[0]}`
                    cloth_path = `${segmentResult1[0]},${segmentResult2[0]}`
                    cloth_mask = `${segmentResult1[4]},${segmentResult2[4]}`
                    mask = {
                        topAlgoId: maskAlgoId1Ref.current,
                        topEditedOutput: segmentResult1,
                        bottomAlgoId: maskAlgoId2Ref.current,
                        bottomEditedOutput: segmentResult2
                    }
                }
            } else {
                _clothType = 3
            }
            obj = {
                cloth_path: cloth_path,
                mote_style: modelStyle, // 模特
                modelKeyList: filteredModelListRef.current, // modalStyle传随机(_default_style)时使用
                person_style: poseStyle, // 姿势
                cloth_mask: cloth_mask,
                version: version,
                bkg_style: bgStyle,
                bgKeyList: filteredBgListRef.current, // bgUrl传随机(_random)时使用
                gender: null, // 由于上传页面删除了服装类别，gender传null由服务端处理
                cloth_type: _clothType,
                seed: -1, // model采用的是tryon的模特，seed目前无效
                sub_bgid: subBgId,
                num: createNum,
                t_model: 3, // 取值1,2,3 全身区域分割v0.2已更新，t_model 传3
                self_defined: isSelfDefinedRef.current ? 1 : 0, //【0-预置模特，1-自定义】
                mote_img: isSelfDefinedRef.current ? selfDefinedImgRef.current : '', // 用户上传得模特图，用于构建模特
                keepPose: keepPose ? 1 : 0, // 
            }
        }

        // 算法类型
        const algoType = 
            imageType == IMAGE_TYPE.MODEL ? ALGO_TYPE.MODEL :
            imageType == IMAGE_TYPE.DRESSFORM ? ALGO_TYPE.DRESSFORM :
            imageType == IMAGE_TYPE.COMMODITY ? (
                refVersion == 3 ?
                    ALGO_TYPE.COMMODITY_REMOVE :
                    ALGO_TYPE.COMMODITY
            ) :
            imageType == IMAGE_TYPE.CLOTHES ? ALGO_TYPE.CLOTHES : ""

        const proInfo = {
            id: projectId,
            projectName: projectName,
            imageType: imageType,
            algoType: algoType,
            inputImage: input_image,
            mask: {
                algoId: "",
                editedOutput: [],
                topAlgoId: "",
                topEditedOutput: [],
                bottomAlgoId: "",
                bottomEditedOutput: [],
                ...mask
            },
            inpaint: {
                algoId: "",
                attr: {
                    person: modelStyle,
                    pose: poseStyle,
                    background: bgStyle,
                    version: version,
                    clothCategory: '',
                    modelFilter: globalModelFilter,
                    imgRatio: imgRatioRef.current,
                    faceTag: faceTag,
                    hairTag: hairTag,
                    faceTagText: faceTagText,
                    hairTagText: hairTagText,
                }
            }
        }
        // console.log('workflowOfBuild', obj)
        // console.log(proInfo)
        // return Promise.resolve(false)
        return await workflowOfBuild(obj, imageType, proInfo, imageAntispamId)
    }

    const middleRef = useRef()
    const onEdgeChange = (url) => {
        middleRef.current.loadNewEdge(url)
    }

    const onCreateCommodityVideo = async () => {
        console.log('生成商品视频')
        // /ps/web/algo/doCommodityVideo 商品视频生成
        // img4Video, videoResolution
        try {
            const res = await maskPrediction(img4Video, IMAGE_TYPE.COMMODITY, () => !isMounted.current)
            // console.log('maskPrediction', res)
            if (!res) return false
            const {id, input, output} = res
            const predictRes = await API.commodityVideoPrediction({
                projectId: projectId,
                img_path: img4Video,
                mask_path: output[4],
                resolution: videoResolution,
                attr: {}
            })
            console.log('predictRes', predictRes)
            if (predictRes.code != 0) throw new Error(predictRes.message)
            message.info('生成中，请稍等片刻')
            setProjectId(predictRes.data.id)
            setRightProjectId(predictRes.data.id)
            forceUpdate({jumpOnce: true})
        } catch (err) {
            message.warning(err.message)
            console.error(err)
        }
    }


    const onCreateModelVideo = async () => {
        try {
            const res = await API.doTryonVideo({
                projectId: projectId,
                ref_img: modelVideoPic,
                ctl_videoKey: modelVideo,
                version: modelVideoVersion,
                num: 1
            })
            if (res.code != 0) {
                if (res.code == -5012) {
                    PSAIModal.confirm({
                        title: "提醒",
                        content: "可用虹豆不足，是否立即充值？",
                        onOk() {
                            eventBus.emit('recharge')
                        },
                        onCancel() {},
                    })
                    return false
                } else throw new Error(res.message)
            }
            setProjectId(res.data.id)
            setRightProjectId(res.data.id)
            forceUpdate({jumpOnce: true})
        } catch (err) {
            message.warning(err.message)
            console.error(err)
        }
    }

    return (
        <div className={styles.Container}>
            <div className={styles.LeftComp}>
            {
                imageType == IMAGE_TYPE.COMMODITY_VIDEO ?
                <LeftCompVideo onCreate={onCreateCommodityVideo} /> :
                imageType == IMAGE_TYPE.MODEL_VIDEO ?
                <LeftModelVideo onCreate={onCreateModelVideo} />:
                <LeftComp
                    segmentResult={segmentResult}
                    onCreate={onCreate}
                    onEdgeChange={onEdgeChange}
                />
            }
            </div>
            <div className={`${styles.MiddleComp} ${!rightProjectId && styles.hidden}`}>
            {
                imageType == IMAGE_TYPE.COMMODITY_VIDEO ?
                <MiddleCompVideo /> :
                imageType == IMAGE_TYPE.MODEL_VIDEO ?
                <MiddleModelVideo />: 
                <MiddleComp ref={middleRef} />
            }
            </div>
            <div className={`${styles.RightComp} ${!rightProjectId && styles.hidden} ${styles[imageType]}`}>
                <RightComp />
            </div>
        </div>
    )
}

const SelfModelFake = (props) => {
    return (
        <GenerateContextProvider imageType={props.imageType}>
            <SelfModelFakeChildren />
        </GenerateContextProvider>
    )
}

export default SelfModelFake